import React from "react";
import Layout from "../../Components/Layout/Layout";
import OrbitIntelChatComponent from "../../Components/OrbitIntelChatComponent/OrbitIntelChatComponent";

const OrbitIntelChatPage = () => {
  return (
    <Layout>
      {/* <div className="child-section-of-everypage-aipath"> */}
        <OrbitIntelChatComponent />
      {/* </div> */}
    </Layout>
  );
};

export default OrbitIntelChatPage;
